import React from "react"

export const InstagramIconSolid = ({ size = 1, color = "#034055" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 28 28"
      width={size * 28}
      height={size * 28}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill={color}
        d="M22.6,2C24.5,2,26,3.5,26,5.4v17.1c0,1.9-1.5,3.4-3.4,3.4H5.4C3.5,26,2,24.5,2,22.6V5.4C2,3.5,3.5,2,5.4,2H22.6
	z M19.1,4.6H8.9C8.5,4.7,8,4.7,7.6,4.9C6,5.6,5,6.8,4.6,8.5C4.6,8.8,4.6,9.2,4.6,9.5c0,3,0,6.1,0,9.1c0,1.7,0.7,3,2,4
	c0.8,0.6,1.7,0.9,2.7,0.9c3.1,0,6.2,0,9.4,0c2.1,0,3.9-1.3,4.5-3.3c0.1-0.3,0.2-0.7,0.2-1.1V8.9c-0.1-0.5-0.2-0.9-0.3-1.3
	c-0.7-1.6-1.9-2.6-3.6-2.9C19.3,4.6,19.2,4.6,19.1,4.6L19.1,4.6z M12.5,6.1l1.5,0v0c1.6,0,3.3,0,4.9,0c1.4,0,2.7,1.2,2.9,2.6
	c0,0.2,0,0.4,0,0.6c0,3.1,0,6.1,0,9.2c0,1.4-0.6,2.4-1.8,3c-0.4,0.2-0.9,0.3-1.4,0.3c-3.1,0-6.2,0-9.3,0c-1.6,0-2.8-1-3.1-2.5
	c-0.1-0.2-0.1-0.5-0.1-0.7c0-3.1,0-6.2,0-9.2c0-1.5,0.9-2.7,2.1-3.1C8.6,6.2,9,6.2,9.4,6.2c1.5,0,3.1,0,4.6,0L12.5,6.1z M14,9.3
	c-2.6,0-4.7,2.1-4.7,4.7c0,2.6,2.1,4.7,4.7,4.7c2.6,0,4.7-2.1,4.7-4.7C18.7,11.4,16.6,9.3,14,9.3L14,9.3z M14,10.9
	c1.7,0,3.1,1.4,3.1,3.1c0,0,0,0,0,0c0,1.7-1.4,3.1-3.1,3.1c0,0,0,0,0,0c-1.7,0-3.1-1.4-3.1-3.1c0,0,0,0,0,0
	C10.9,12.3,12.3,10.9,14,10.9C14,10.9,14,10.9,14,10.9z M19.1,7.7c-0.7,0-1.2,0.5-1.2,1.2c0,0,0,0,0,0c0,0.6,0.5,1.2,1.2,1.2
	c0.7,0,1.2-0.5,1.2-1.2C20.3,8.2,19.8,7.7,19.1,7.7L19.1,7.7z"
      />
    </svg>
  )
}
